import Vue from 'vue'
import VueI18n from 'vue-i18n'

const messages = {
  fr: {
    help: {
      label: {
        sourceInfos: {
          refSourceInfo: "CDS, DDE, DIREN, carte IGN ...",
          lieuArchivage: "lieu où se trouve les documents source (BRGM, CDS, DDE ...)"
        },
        confidentialite: {
          raison: "Contrainte environnementale (Natura2000...), site archéologique, risque avéré (effondrement, poche de gaz...) , ..."
        },
        contour: {
          fileType: "Type de fichier : shapefile"
        },
        cavitesAssociees: "Autre entrée ou autre orifice de la même cavité",
        precision: "fonction du positionnement : précise = précision 5 à 25 m ; approchée ou milieu de rue = précision > 25 m ; imprécise = précision > 250 m ; centroïde de commune = 1000m."
      },
      inline: {
        sourceInfos: {
          refSourceInfo: '(Ressource exploitée : organisme, visite, bibliographie, internet ...)',
          lieuArchivage: 'Accès à la données : référence biblio, adresse internet, organisme où est stockée ...'
        }
      }
    }
  }
};

Vue.use(VueI18n);

const inst = new VueI18n({
  locale: 'fr', // set locale
  fallbackLocale: 'en',
  messages // set locale messages
});

const $t = inst.t.bind(inst);

export default inst;
export { $t };
